export default "__VITE_ASSET__DNO0fv_y__"